class fieldService {
	constructor(config) {
		this.config = Object.assign({
			scope: '.field_service'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		$('button[data-toggle="tab"]').on('shown.bs.tab', function (event){

		});
	}

}

export default new fieldService;